import AsyncLoader from 'component/AsyncLoader';

export const MerchantInfo =  AsyncLoader(() => import('./MerchantInfo'));
export const CooperationInfo =  AsyncLoader(() => import('./CooperationInfo'));
export const CustomContract =  AsyncLoader(() => import('./CustomContract'));
export const SignCode =  AsyncLoader(() => import('./SignCode'));
export const ContractSett =  AsyncLoader(() => import('./ContractSett'));
export const RechargeReceipt =  AsyncLoader(() => import('./RechargeReceipt'));
export const InfomationCode =  AsyncLoader(() => import('./InfomationCode'));